import { useTranslation } from "react-i18next";
import { Check, Globe } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { SUPPORTED_LANGS } from "../lib/i18n";

export default function LanguageSwitcher({ compact = false }) {
  const { i18n } = useTranslation();
  const current = SUPPORTED_LANGS.find((l) => l.code === i18n.language) || SUPPORTED_LANGS[0];

  const switchTo = (code) => {
    i18n.changeLanguage(code);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className="inline-flex items-center gap-1.5 px-3 h-9 rounded-full border border-brand-line bg-white/80 hover:bg-white text-sm font-medium text-brand-ink transition-colors"
        data-testid="language-switcher"
        aria-label="Change language"
      >
        <Globe className="w-3.5 h-3.5 text-brand-inkSoft" />
        <span className="text-xs font-bold tracking-wide">{current.short}</span>
        {!compact && <span className="text-base leading-none">{current.flag}</span>}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44 bg-white">
        {SUPPORTED_LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onSelect={() => switchTo(l.code)}
            className="flex items-center gap-3 cursor-pointer"
            data-testid={`lang-option-${l.code}`}
          >
            <span className="text-lg leading-none">{l.flag}</span>
            <span className="flex-1 text-sm">{l.label}</span>
            {l.code === current.code && (
              <Check className="w-4 h-4 text-brand-gold" />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
